import { get, sumBy } from "lodash";

const phoneNumberCountryCodePrefix = "+";
const phoneNumberSeparator = " ";
export const phoneNumberFormat = `${phoneNumberCountryCodePrefix}999${phoneNumberSeparator}999999999999999`;

export const phoneNumberMask = phoneNumberFormat
  .split("")
  .map(c => (c === "9" ? /\d/ : c));

export const canGetNumberFromPhoneNumber = (v?: string) => {
  if (!v) {
    return false;
  }

  const strippedValue = v
    ?.slice(phoneNumberCountryCodePrefix.length)
    .split(phoneNumberSeparator)
    .join("")
    .trim();

  return !!strippedValue.match(/^[0-9]+$/);
};

export const moneyMaskOptions = {
  prefix: "$",
  suffix: "",
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ",",
  allowDecimal: true,
  decimalSymbol: ".",
  decimalLimit: 2,
  allowNegative: false,
  allowLeadingZeroes: false,
  integerLimit: 9,
};

export const canGetNumberFromMoneyValue = (v?: string | null) => {
  // it must start with the dollar sign prefix
  if (!v || get(v, 0, "") !== moneyMaskOptions.prefix) {
    return false;
  }

  // there should be 1 (double values) or 0 (integer values) decimal symbols
  if (
    sumBy(v, character =>
      character === moneyMaskOptions.decimalSymbol ? 1 : 0,
    ) > 1
  ) {
    return false;
  }

  const strippedValue = v
    .slice(moneyMaskOptions.prefix.length)
    .split(moneyMaskOptions.thousandsSeparatorSymbol)
    .join("")
    .split(moneyMaskOptions.decimalSymbol)
    .join("")
    .trim();

  return !!strippedValue.match(/^[0-9]+$/);
};

export const getValidatedInteger = (
  value: string | null | undefined,
): number | null => {
  if (!value) {
    return null;
  }

  const isInteger = get(value.match(/[0-9]+/), 0, "").length === value.length;

  return isInteger ? parseInt(value) : null;
};
